var component = /-?\d+(\.\d+)?%?/g;
function extractComponents(color) {
  return color.match(component);
}

module.exports = extractComponents;


//////////////////
// WEBPACK FOOTER
// ../~/_pure-color@1.3.0@pure-color/parse/extractComponents.js
// module id = 588
// module chunks = 0